
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sql-templates",
      function () {
        return require("private-next-pages/sql-templates/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sql-templates"])
      });
    }
  